import React from "react";

const COLUMN_ROW_COUNTS = [
  [6, 2],
  [3, 2],
  [5, 1],
];

const PricingCatalogSkeleton = ({ columns = 3 }) => (
  <div
    className="pricing-catalog-board-grid pricing-catalog-skeleton-grid"
    aria-busy="true"
    aria-label="Loading pricing catalog"
  >
    {Array.from({ length: columns }).map((_, colIndex) => (
      <div key={`skel-col-${colIndex}`} className="pricing-catalog-board-column">
        {(COLUMN_ROW_COUNTS[colIndex] ?? [4, 2]).map((rowCount, cardIndex) => (
          <div key={`skel-card-${colIndex}-${cardIndex}`} className="pricing-skeleton-card">
            <div className="pricing-skeleton-block pricing-skeleton-header" />
            <div className="pricing-skeleton-body">
              {Array.from({ length: rowCount }).map((__, rowIndex) => (
                <div key={rowIndex} className="pricing-skeleton-product-row">
                  <div className="pricing-skeleton-block pricing-skeleton-icon" />
                  <div className="pricing-skeleton-block pricing-skeleton-name" />
                  <div className="pricing-skeleton-block pricing-skeleton-variant" />
                  <div className="pricing-skeleton-block pricing-skeleton-price" />
                  <div className="pricing-skeleton-block pricing-skeleton-delete" />
                </div>
              ))}
            </div>
            <div className="pricing-skeleton-block pricing-skeleton-footer" />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default PricingCatalogSkeleton;
